import BillingProfiles from "@/modules/billing/views/BillingProfiles.vue";
import BillingProfilesEdit from "@/modules/billing/views/BillingProfileEdit.vue";
import BillingProfileView from "@/modules/billing/views/BillingProfileView.vue";

export const BillingRoutes = [
    {
        path: '/billing/profiles',
        component: BillingProfiles,
    },
    {
        path: '/billing/profiles/create',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/createbycustomer',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/edit',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/view/admin',
        component: BillingProfileView,
    },
    {
        path: '/billing/profiles/view/user',
        component: BillingProfileView,
    }
];
